import { defineComponent as _defineComponent } from 'vue';
import UtcDate from "@/components/UtcDate.vue";
import { formatDistanceToNow, parseISO } from "date-fns";
import { library } from "@fortawesome/fontawesome-svg-core";
import AsyncButton from "@/components/Common/AsyncButton.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BInputGroup, BCol, BRow, BButton } from "bootstrap-vue";
import { faHourglassHalf } from "@fortawesome/free-solid-svg-icons";
import { useNotificationsStore } from "@/stores/notificationsStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationActions',
    props: {
        notification: null
    },
    setup(__props) {
        library.add(faHourglassHalf);
        const notificationsStore = useNotificationsStore();
        function getNotificationExpirationTitle(notification) {
            if (notification.expiration_time) {
                const expirationTime = parseISO(notification.expiration_time);
                return `This notification will be automatically deleted ${formatDistanceToNow(expirationTime, {
                    addSuffix: true,
                })}`;
            }
            else {
                return "This notification will never be automatically deleted";
            }
        }
        return { __sfc: true, notificationsStore, getNotificationExpirationTitle, UtcDate, AsyncButton, FontAwesomeIcon, BInputGroup, BCol, BRow, BButton };
    }
});
